import { useState, useEffect } from "react"
import '../../css/Rules/Rules.css'
import { useTranslation } from "react-i18next";
import { domain } from "../Links/Links";

function Rules({ theme }) {
    const [rulesText, setRulesText] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t('Hiket, Rules');

        const xhr = new XMLHttpRequest();
        xhr.open('GET', domain + '/rules_api/', true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                if (data) {
                    setRulesText(data.rules_text);
                }
            }
        }
        xhr.send();
    }, []);

    return (
        <div className="ppeoo293k">
            <div className="ppeoormvf">
                {!rulesText ? (
                    <div className={`ppeoo3iiv shimmer ${theme}`}></div>
                ) : (
                    <div className="orpp3omvf">{rulesText}</div>
                )}
            </div>
        </div>

    )
}

export default Rules